import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/CreditCardAuth';

/** 取得條款說明 */
export function getAgreeTermsCreditCardAuth() {
    return get(`${url}/getAgreeTerms`);
}

/** 條款同意 */
export function postAgreeCreditCardAuth() {
    return post(`${url}/agree`);
}

/** 取得可信用卡授權保單 */
export function getInfoCreditCardAuth() {
    return get(`${url}/info`);
}

export function postCardBankName(data) {
    return post(`${url}/queryCardBankName`, data, { ...options, repeatRequestCancel: true });
}

export function submitCreditCartAuthInfo(data) {
    return post(`${url}/submitCreditCardInfo`, data, { ...options, repeatRequestCancel: true });
}

/** 送出選擇信用卡授權保單 */
export function submitCreditCardAuth(data) {
    return post(`${url}/submitPolicy`, data, { ...options, repeatRequestCancel: true });
}
